import React from 'react'
import {
    List,
    Datagrid,
    TextField,
    NumberField,
} from 'react-admin'


export const SistemaInterconectadoList = props => (
    <List {...props} exporter={false} >
        <Datagrid rowClick="show">
            <NumberField source="id" />
            <TextField source="name" />
            <TextField source="code" />
        </Datagrid>
    </List>
);
